var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.isEdit
          ? _vm.$t("EDIT_CLIENT_USER")
          : _vm.$t("ADD_CLIENT_USER"),
        visible: "",
        width: "40%",
      },
      on: { close: _vm.onCancel },
    },
    [
      _c(
        "el-form",
        {
          ref: "ruleForm",
          staticClass: "demo-ruleForm",
          attrs: {
            model: _vm.ruleForm,
            rules: _vm.rules,
            "label-width": "240px",
          },
        },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("USER_WORKING_EMAIL"),
                prop: "userAccount",
              },
            },
            [
              _c("el-autocomplete", {
                staticClass: "inline-input email-inpu-cls",
                attrs: {
                  disabled: _vm.isEdit,
                  maxlength: 100,
                  "fetch-suggestions": _vm.querySearch,
                  placeholder: _vm.$t("email_warn"),
                  "trigger-on-focus": false,
                },
                on: {
                  change: function ($event) {
                    return _vm.userAccountChange(false)
                  },
                  select: function ($event) {
                    return _vm.userAccountChange(false)
                  },
                },
                model: {
                  value: _vm.ruleForm.userAccount,
                  callback: function ($$v) {
                    _vm.$set(_vm.ruleForm, "userAccount", $$v)
                  },
                  expression: "ruleForm.userAccount",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("COMMON_USER_NAME"), prop: "userName" } },
            [
              _c("el-input", {
                attrs: { maxlength: "50" },
                model: {
                  value: _vm.ruleForm.userName,
                  callback: function ($$v) {
                    _vm.$set(_vm.ruleForm, "userName", $$v)
                  },
                  expression: "ruleForm.userName",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("TABLE_HEADER_title2"), prop: "title" } },
            [
              _c("el-input", {
                attrs: { maxlength: "50" },
                model: {
                  value: _vm.ruleForm.title,
                  callback: function ($$v) {
                    _vm.$set(_vm.ruleForm, "title", $$v)
                  },
                  expression: "ruleForm.title",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("TABLE_HEADER_CLIENT_IDENTITY"),
                prop: "identityType",
              },
            },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    placeholder: _vm.$t("TABLE_HEADER_CLIENT_IDENTITY"),
                    filterable: "",
                  },
                  model: {
                    value: _vm.ruleForm.identityType,
                    callback: function ($$v) {
                      _vm.$set(_vm.ruleForm, "identityType", $$v)
                    },
                    expression: "ruleForm.identityType",
                  },
                },
                _vm._l(_vm.identityTypeOpt, function (item) {
                  return _c("el-option", {
                    key: item.code,
                    attrs: { label: item.value, value: item.code },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _vm.initData.id
            ? _c(
                "el-form-item",
                {
                  attrs: { label: _vm.$t("BACKUP_MAILBOX"), prop: "backMail" },
                },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: _vm.$t("BACKUP_MAILBOX_DESC"),
                      maxlength: "50",
                    },
                    model: {
                      value: _vm.ruleForm.backMail,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "backMail", $$v)
                      },
                      expression: "ruleForm.backMail",
                    },
                  }),
                  _c("div", { staticClass: "backup-warning" }, [
                    _vm._v("* " + _vm._s(_vm.$t("BACKUP_MAILBOX_WARNING"))),
                  ]),
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("TABLE_HEADER_ifContact"),
                prop: "ifContact",
              },
            },
            [
              _c("el-switch", {
                staticClass: "switch-width-cls",
                attrs: {
                  "active-color": "#409EFF",
                  "inactive-color": "#cccccc",
                },
                model: {
                  value: _vm.ruleForm.ifContact,
                  callback: function ($$v) {
                    _vm.$set(_vm.ruleForm, "ifContact", $$v)
                  },
                  expression: "ruleForm.ifContact",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.titleTipSites,
                  expression: "titleTipSites",
                },
              ],
              staticClass: "autofill-tip",
            },
            [
              _vm._v(
                "\n            " +
                  _vm._s(
                    _vm.$t("clientUserAddTitleTip", {
                      sites: _vm.titleTipSites,
                    })
                  ) +
                  "\n        "
              ),
            ]
          ),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            { staticClass: "cancel-btn", on: { click: _vm.onCancel } },
            [_vm._v(_vm._s(_vm.$t("comment_reSet")))]
          ),
          _c(
            "el-button",
            {
              staticClass: "wl-green",
              attrs: { type: "primary", loading: _vm.saveLoading },
              on: { click: _vm.onConfirm },
            },
            [_vm._v(_vm._s(_vm.$t("btn_save")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }